/**
 * 変換ステータス
 */
export var ConversionStatuses;

(function (ConversionStatuses) {
  /**
   * 未処理
   */
  ConversionStatuses[ConversionStatuses["Untreated"] = 0] = "Untreated";
  /**
   * 処理待ち
   */

  ConversionStatuses[ConversionStatuses["Wait"] = 1] = "Wait";
  /**
   * 処理中
   */

  ConversionStatuses[ConversionStatuses["Processing"] = 2] = "Processing";
  /**
   * 正常終了
   */

  ConversionStatuses[ConversionStatuses["Success"] = 3] = "Success";
  /**
   * 異常終了
   */

  ConversionStatuses[ConversionStatuses["Failure"] = 4] = "Failure";
  /**
   * 要求なし
   */

  ConversionStatuses[ConversionStatuses["NoRequest"] = 9] = "NoRequest";
})(ConversionStatuses || (ConversionStatuses = {}));